export const MFA_GENERATE_EMAIL_VERIFICATION_CODE_KEY = 'generateEmailVerificationCode';
export const MFA_UPDATE_EMAIL_METHOD_KEY = 'updateEmailUserMethodEndpoint';
export const MFA_UPDATE_SMS_METHOD_KEY = 'updateSmsUserMethodEndpoint';
export const MFA_UPDATE_PREFERRED_METHOD_KEY = 'updatePreferredMethodEndpoint';
export const SMS_METHOD_CODE = 'sms';
export const EMAIL_METHOD_CODE = 'email';
